import { UploadVideoToBlendVisionServiceParams, useUploadVideoToBlendVisionService } from '@/hooks/useUploadVideoToBlendVisionService';
import { uploadImageAction } from '@/server/lib/upload';
export const useUploadMediaToService = () => {
  const {
    uploadVideoToBlendVisionService
  } = useUploadVideoToBlendVisionService();
  const uploadMediaToService = async (params: UploadVideoToBlendVisionServiceParams) => {
    const {
      file
    } = params;
    if (!file) {
      return;
    }
    try {
      if (file.type.includes('video')) {
        return await uploadVideoToBlendVisionService(params);
      } else {
        const result = await uploadImageAction(file);
        if (!result.ok) throw new Error(result.error);
        return result.url;
      }
    } catch (error) {
      console.error(`❌ upload to service failed: ${file.name} `, error);
    }
  };
  return uploadMediaToService;
};